import type { InferType } from 'yup';
import { object, string } from 'yup';

import { CONFIRMATION_FORM_FIELDS } from './PreApprovalConfirmationForm.config';

export const schema = () =>
  object({
    [CONFIRMATION_FORM_FIELDS.SMS_CODE]: string()
      .transform((value) => (value == null ? '' : String(value).replace(/\D/g, '')))
      .required('Введите код')
      .length(4, 'Неверный код'),
  });

export type ConfirmationFormValues = InferType<ReturnType<typeof schema>>;
